// extracted by mini-css-extract-plugin
module.exports = {"title":"_2XPNeVY1mS"};
    if(module.hot) {
      // 1597843260312
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  